import PropTypes from "prop-types";
import React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";

const MarkerLegend = () =>
  <div className="apl-legend">
    <h3>
      <FormattedMessage {...messages.colourGuideHeaderDescription} />
    </h3>
    <ul>
      <li className="apl-legend__risk apl-legend__risk--high">
        <FormattedMessage {...messages.unhealthyHighRiskDescription} />
      </li>
      <li className="apl-legend__risk apl-legend__risk--moderate">
        <FormattedMessage {...messages.cautionModerateRiskDescription} />
      </li>
      <li className="apl-legend__risk apl-legend__risk--low">
        <FormattedMessage {...messages.healthLowRiskDescription} />
      </li>
    </ul>
  </div>;

MarkerLegend.propTypes = {
  messages: PropTypes.object,
};

export default injectIntl(MarkerLegend);



// WEBPACK FOOTER //
// ./components/employee/wellness/markerLegend.jsx